// removed by extract-text-webpack-plugin
module.exports = {"List":"_2RoIr1MQql0I1zRGmJSHl3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationList/styles.css
// module id = 715
// module chunks = 0